export const HEADER_COLOR = '#D3D3D3';
export const PAGE_BORDER_WIDTH = 2;
export const FULL_WIDTH = 216 - PAGE_BORDER_WIDTH * 2;
export const FULL_HEIGHT = 355;
export const SECTION_GAP_WIDTH = 2;
export const LINE_Y_OFFSET = 0.5;
export const HEADER_HEIGHT = 24;
export const HEADER_WIDTH = FULL_WIDTH;
export const HEADER_LEFT = PAGE_BORDER_WIDTH;
export const HEADER_TOP = PAGE_BORDER_WIDTH;
export const ROW_SECTION_HEADER_HEIGHT = 4;
export const THIN_LINE = 0.25;
export const THICK_LINE = 0.5;

export const HEADER_1_SIZE = 9;
export const HEADER_2_SIZE = 7;
export const LOGO_LEFT = 2;
export const LOGO_TOP = PAGE_BORDER_WIDTH;
export const LOGO_WIDTH = 50;
export const LOGO_HEIGHT = 23;

export const OPERATOR_CONTRACTOR_TOP = PAGE_BORDER_WIDTH + 2;
export const OPERATOR_CONTRACTOR_LEFT = PAGE_BORDER_WIDTH + LOGO_WIDTH + 3;
export const OPERATOR_CONTRACTOR_WIDTH = 150;
export const OPERTAOR_CONTRACTOR_HEIGHT = 20;

export const DEPTH_TOP = PAGE_BORDER_WIDTH + 2;
export const DEPTH_LEFT = OPERATOR_CONTRACTOR_LEFT + OPERATOR_CONTRACTOR_WIDTH - 20;
export const DEPTH_WIDTH = FULL_WIDTH - DEPTH_LEFT - PAGE_BORDER_WIDTH;
export const DEPTH_HEIGHT = OPERTAOR_CONTRACTOR_HEIGHT;

export const TOTALS_TOP = HEADER_TOP + HEADER_HEIGHT + ROW_SECTION_HEADER_HEIGHT;
export const TOTALS_LEFT = PAGE_BORDER_WIDTH;
export const TOTALS_HEIGHT = 20;
export const TOTALS_WIDTH = FULL_WIDTH;
export const TOTALS_COLUMNS = 6;
export const TOTALS_ROWS = 2;

export const PRODUCTS_TOP = TOTALS_HEIGHT + TOTALS_TOP + ROW_SECTION_HEADER_HEIGHT;
export const PRODUCTS_LEFT = PAGE_BORDER_WIDTH;
export const PRODUCTS_HEIGHT = FULL_HEIGHT - PRODUCTS_TOP - PAGE_BORDER_WIDTH;
export const PRODUCTS_WIDTH = FULL_WIDTH;

export const PRODUCTS_ROWS = 48;

export const DATA_TOP = HEADER_TOP + HEADER_HEIGHT + ROW_SECTION_HEADER_HEIGHT;
export const DATA_LEFT = PAGE_BORDER_WIDTH;
export const DATA_WIDTH = FULL_WIDTH;
export const DATA_HEIGHT = FULL_HEIGHT - ROW_SECTION_HEADER_HEIGHT - HEADER_HEIGHT - PAGE_BORDER_WIDTH * 2;

export const DATA_ROWS = 56;
export const PRODUCTS_COLUMNS = 11;



// WEBPACK FOOTER //
// ./src/Services/Pdf/ProductInventorySnapshot/SpecMilsProductInventory.ts